export const SUPPORT_EMAIL = 'support@parks-avenue.com'
export const PRIVACY_EMAIL = 'privacy@parks-avenue.com'
export const COMPANY_NAME = 'ETARIP LLC'
export const DBA_NAME = 'Parks Avenue'
export const WEBSITE_URL = 'parks-avenue.com'

export const SUPPORT_PHONE = '+1 (229) 530-2299'
export const SUPPORT_PHONE_TEL = '+12295302299'

export const COMPANY_ADDRESS_LINE1 = '46510 Roudel Ln'
export const COMPANY_ADDRESS_LINE2 = 'La Quinta, CA 92253, United States'

// Business hours displayed on the Contact page (Wells Fargo requirement)
export const SUPPORT_HOURS = 'Monday to Friday, 9:00 AM – 6:00 PM (Pacific Time)'
